import React from "react";
import { PrimeIcons } from "primereact/api";
import { useHistory } from "react-router-dom";

import { TawreedAction, TawreedActionName } from "../../../../../common/actions";
import { TawreedTable, TawreedTableProps } from "../../../../../common/components/table";
import { CssUtils } from "../../../../../helpers/css";
import { Routes } from "../../../../../router";
import { PaymentTransaction, PaymentTransactionService } from "../../../domain";
import { TawreedTableFilters } from "../../../../../common/components/table/filters";
import { GlobalContext } from "../../../../../context";
import { TawreedTableFormatters } from "../../../../../common/components/table/formatters";


export const PaymentTransactionTable: React.FC = () => {
    const history = useHistory();
    const service = React.useMemo(() => new PaymentTransactionService(), []);
    const { auth:{user}, constants: { constants } } = React.useContext(GlobalContext);

    const onDetails = (sender?: PaymentTransaction): Promise<void> => {
        return new Promise((resolve, reject) => {
            if (sender && sender.paymentTransactionId) {
                history.push(Routes.PaymentTransactionDetails.replace(':id', sender.paymentTransactionId.toString()));
                resolve();
            } else {
                reject();
            }
        });
    }

    const tawreed: TawreedTableProps = {
        header: true,
        pagination: true,
        dataKey: 'paymentTransactionId',
        name: 'tbl.payment.transactions',
        title: 'lbl_payment_transactions',
        ds: {
            mode: 'lazy',
            onSearch: (req) => service.search(req),
        },
        columns: [
            {
                field: "paymentTransactionId",
                header: "lbl_payment_txn_paymentTransactionId",
                sortable: true,
                filter: true,
                style: CssUtils.width('15%'),
            },
            {                
                field: "createdAt",
                header: "lbl_payment_txn_createdat",
                sortable: true,
                filter: true,
                style: CssUtils.width('15%'),
                ...TawreedTableFilters.date.range("createdAt", 'datetime'),
            },
            {
                field: "paymentPartner.partnerName",
                header: "lbl_payment_txn_payment_partner",
                sortable: true,
                sortField: 'paymentPartnerName',
                filter: true,
                filterField: 'paymentPartnerName',
                style: CssUtils.width('20%'),
            },
            {
                field: "sellerPartner.partnerName",
                header: "lbl_payment_txn_seller_partner",
                sortable: true,
                sortField: 'sellerName',
                filter: true,
                filterField: 'sellerName',
                style: CssUtils.width('20%'),
            },
            {
                field: "buyerPartner.partnerName",
                header: "lbl_payment_txn_buyer_partner",
                sortable: true,
                sortField: 'buyerName',
                filter: true,
                filterField: 'buyerName',
                style: CssUtils.width('20%'),
            },
            {
                field: "amount",
                header: "lbl_payment_txn_amount",
                sortable: true,
                filter: true,
                ...TawreedTableFormatters.decimal('amount',user?.scale, undefined, CssUtils.width('15%')),
            },
            {
                field: "status",
                header: "lbl_payment_txn_txnstatus",
                sortable: true,
                filter: true,
                style: CssUtils.width('15%'),
                ...TawreedTableFilters.dropdown.dropdown("status", constants && constants.paymentransactionStatuses ? constants.paymentransactionStatuses : [], 'value', 'label', 'in'),
            },
        ],
        row: {
            onClick: new TawreedAction(TawreedActionName.PaymentTransactionsDetails, 'statefull', 'lbl_info', PrimeIcons.INFO, onDetails, 'p-button-secondary', false),
        },
        filter: {
            filterDisplay: 'menu',
            initial: {
                'paymentTransactionId': {
                    operator: 'AND',
                    constraints: [
                        {
                            value: null,
                            matchMode: 'equals',
                        },
                    ]
                },
                'createdAt': {
                    operator: 'AND',
                    constraints: [
                        {
                            value: null,
                            matchMode: 'dateIs',
                        },
                    ]
                },
                'paymentPartnerName': {
                    operator: 'AND',
                    constraints: [
                        {
                            value: null,
                            matchMode: 'contains',
                        },
                    ]
                },
                'sellerName': {
                    operator: 'AND',
                    constraints: [
                        {
                            value: null,
                            matchMode: 'contains',
                        },
                    ]
                },
                'buyerName': {
                    operator: 'AND',
                    constraints: [
                        {
                            value: null,
                            matchMode: 'contains',
                        },
                    ]
                },
                'amount': {
                    operator: 'AND',
                    constraints: [
                        {
                            value: null,
                            matchMode: 'equals',
                        },
                    ]
                },
                'status': {
                    operator: 'AND',
                    constraints: [
                        {
                            value: null,
                            matchMode: 'equals',
                        },
                    ]
                },                
            },
        },
        sort: {
            sortMode: 'single',
            initial: {
                sortField: 'createdAt',
                sortOrder: -1,
                multiSortMeta: undefined,
            },
        },
        selection: {
            mode: 'checkbox',
        },
    }
    return (<TawreedTable  {...tawreed} />);
}